var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.35938,
    y: 8.95361,
    width: 12.1923,
    height: 12.1923,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5C3.35775 11.6422 3.35775 18.3578 7.5 22.5C11.6422 26.6422 18.3577 26.6422 22.5 22.5C26.6422 18.3578 26.6422 11.6422 22.5 7.5C18.3577 3.35775 11.6422 3.35775 7.5 7.5ZM18.75 11.25C19.1642 11.6642 19.1642 12.3358 18.75 12.75L16.5 15L18.75 17.25C19.1642 17.6642 19.1642 18.3358 18.75 18.75C18.3358 19.1642 17.6642 19.1642 17.25 18.75L15 16.5L12.75 18.75C12.3358 19.1642 11.6642 19.1642 11.25 18.75C10.8358 18.3358 10.8358 17.6642 11.25 17.25L13.5 15L11.25 12.75C10.8358 12.3358 10.8358 11.6642 11.25 11.25C11.6642 10.8358 12.3358 10.8358 12.75 11.25L15 13.5L17.25 11.25C17.6642 10.8358 18.3358 10.8358 18.75 11.25Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCross);
export default __webpack_public_path__ + "static/media/blackCross.10faa2debc0ca0ee4f9d97681b6f3164.svg";
export { ForwardRef as ReactComponent };